export enum AccessType {
  MerchantAdmin = 'MerchantAdmin',
  LoyaltyProgramAdmin = 'LoyaltyProgramAdmin',
  Billing = 'Billing',
  RepresentativeAdmin = 'RepresentativeAdmin',
  OfferAdmin = 'OfferAdmin',
  ConsumerAdmin = 'ConsumerAdmin',
  TeamAdmin = 'TeamAdmin',
}
